import { MembersRoomDto } from '../models/dto/room-members.dto';

export const createMembers = (
  name: string,
  members: string[]
): MembersRoomDto => {
  return {
    roomName: name,
    idsMembers: members,
  };
};
